import React, { useState } from "react";
import "./App.scss";

import Login from "./components/login/login";
import { User } from "./types/User";
import UserCard from "./components/user-card/user_card";
import FilmList from "./components/film-list/film_list";
import { Route, Routes, Navigate } from "react-router-dom";

function App() {
  const [currentUser, setCurrentUser] = useState<User | null>();
  return (
    <div className="app-body">
      <div className={"header-bar"}>
        <div className="page-title">Honk-Worthy Films</div>
        {currentUser && (
          <UserCard onLogout={() => setCurrentUser(null)} user={currentUser} />
        )}
      </div>
      <Routes>
        <Route path="/" element={<Navigate to="/login" />}></Route>
        <Route
          path="/login"
          element={<Login onUserUpdate={setCurrentUser} />}
        />
        <Route
          path="/movies"
          element={
            currentUser ? (
              <FilmList currentUser={currentUser}></FilmList>
            ) : (
              <Navigate to="/login"></Navigate>
            )
          }
        />
      </Routes>
    </div>
  );
}

export default App;
